import React, { useEffect, useState, Fragment } from 'react';
import {
    Checkbox,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TablePagination,
    Link,
    TextField,
    Tooltip,
    FormControlLabel
} from '@mui/material';

const SingleRowExpand = ({
    quoteId,
    pageName,
    data,
    getPageNo,
    analysisGridLoad,
    handleUpdate,
    setAnalysisFeeResponse,
    setGetSelectedRowId,
    getSelectedRowId,
    setIsEnablePriceTable,
    resetSelectedIds,
    loading
}: any) => {
    const [page, setPage] = useState(0);
    const [analysisResult, setAnalysisResult] = useState([] as any[]);
    const [rowsPerPage, setRowsPerPage] = useState(20);
    const [state, setState] = useState(0);
    const [selectAll, setSelectAll] = useState(false);

    useEffect(() => {
        if (page) {
            getPageNo(page);
        }
    }, [page])

    useEffect(() => {
        if (data) {
            loadScreen(data);
        }
    }, [data])

    useEffect(() => {
        if (resetSelectedIds) {
            loadScreen(data);
        }
    }, [resetSelectedIds])

    const loadScreen = (val: any) => {
        val.map((i: any) => {
            i.isSelected = false;
            i.isOpen = false;
        })
        setAnalysisResult(val);
    }

    useEffect(() => {
        if (quoteId) {
            analysisGridLoad(quoteId);
        }
    }, [quoteId])

    const handleChangePage = (
        event: React.MouseEvent<HTMLButtonElement> | null,
        newPage: number,
    ) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (
        event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
    ) => {
        setRowsPerPage(parseInt(event.target.value, 20));
    };

    const handlePriceUpdate = (event: any, user: any) => {
        handleRowUpdate(event, user, 'isUpdate', 'Price');
    }

    // const handleSampleNoUpdate = (event: any, user: any) => {
    //     let arr: any = [];
    //     let obj: object = {};
    //     if (user.linkedTests !== null) {
    //         user.linkedTests.map((item: any) => {
    //             obj = {
    //                 "id": item.id,
    //                 "quoteID": item.quoteID,
    //                 "noOfSamples": Number(event.target.value),
    //                 "testPrice": item.testPrice
    //             }
    //             arr.push(obj);
    //         })
    //     } else {
    //         obj = {
    //             "id": user.id,
    //             "quoteID": user.quoteID,
    //             "noOfSamples": Number(event.target.value),
    //             "testPrice": user.testPrice
    //         }
    //         arr.push(obj);
    //     }
    //     user['lineTotal'] = (user.noOfSamples * user.testPrice).toFixed(2);
    //     if (user.noOfSamples > 0 && user.testPrice > 0) {
    //         handleUpdate(arr, 'SampleNo');
    //     }
    //     handleUpdateList(user);
    // }

    const handleRowUpdate = (event: any, user: any, type: any, sender: any) => {
        if (type === 'isUpdate') {
            user['lineTotal'] = (user.noOfSamples * event.target.value).toFixed(2);
        } else {
            user['hasCharges'] = event.target.value;
        }
        let obj = {
            "id": user.id,
            "quoteID": user.quoteID,
            "testID": user.testID,
            "testPrice": event.target.value,
            "noOfSamples": user.noOfSamples,
            "lineTotal": (user.noOfSamples * event.target.value).toFixed(2),
            "HasCharges": user.hasCharges
        }
        handleUpdate(obj, sender);
        handleUpdateList(user);
    }

    const handleUpdateList = (user: any) => {
        let item = [...analysisResult];
        let lastBookIndex = item.findIndex((i) => i.id === user.id);
        if (lastBookIndex !== -1) {
            item[lastBookIndex] = user;
        }
        setAnalysisFeeResponse(item);
    }

    const handleParentSelection = (parentId) => {
        setAnalysisResult((prevData) =>
            prevData.map((parent) => {
                if (parent.id === parentId) {
                    const newSelected = !parent.isSelected;
                    const updatedChildren = parent?.linkedTests?.map((child) => ({
                        ...child,
                        isSelected: newSelected
                    }));

                    let updatedSelectedIds: any;

                    if (updatedChildren) {
                        updatedSelectedIds = newSelected
                            ? [...getSelectedRowId, parentId, ...updatedChildren?.map(child => child.id)]
                            : getSelectedRowId.filter(id => id !== parentId && !updatedChildren?.map(child => child.id).includes(id));
                    } else {
                        updatedSelectedIds = newSelected
                            ? [...getSelectedRowId, parentId]
                            : getSelectedRowId.filter(id => id !== parentId);
                    }

                    setGetSelectedRowId([...new Set([...updatedSelectedIds])]);
                    return {
                        ...parent,
                        isSelected: newSelected,
                        linkedTests: updatedChildren
                    };
                }
                return parent;
            })
        );
    };

    const handleChildSelection = (parentId, childId) => {
        setAnalysisResult((prevData) =>
            prevData.map((parent) => {
                if (parent.id === parentId) {
                    const updatedChildren = parent?.linkedTests?.map((child) => {
                        if (child.id === childId) {
                            return { ...child, isSelected: !child.isSelected };
                        }
                        return child;
                    });

                    const allChildrenSelected = updatedChildren?.every(child => child.isSelected);

                    const newParentSelected = allChildrenSelected;

                    let updatedSelectedIds = getSelectedRowId;
                    if (allChildrenSelected) {
                        updatedSelectedIds = [...new Set([...updatedSelectedIds, parentId, ...updatedChildren.map(child => child.id)])];
                    } else {
                        updatedSelectedIds = updatedSelectedIds.filter(id => id !== parentId);
                        updatedChildren.forEach(child => {
                            if (child.isSelected) {
                                if (!updatedSelectedIds.includes(child.id)) {
                                    updatedSelectedIds.push(child.id);
                                }
                            } else {
                                updatedSelectedIds = updatedSelectedIds.filter(id => id !== child.id);
                            }
                        })
                    }
                    setGetSelectedRowId([...new Set([...updatedSelectedIds])]);

                    return {
                        ...parent,
                        isSelected: newParentSelected,
                        linkedTests: updatedChildren
                    };
                }
                return parent;
            })
        );
    };

    const handleSelectAll = () => {
        const newSelectAll = !selectAll;
        setSelectAll(newSelectAll);

        const newData = analysisResult.map(parent => {
            const updatedChildren = parent.linkedTests
                ? parent.linkedTests.map(child => ({ ...child, isSelected: newSelectAll }))
                : null;
            return { ...parent, isSelected: newSelectAll, linkedTests: updatedChildren };
        });

        setAnalysisResult(newData);

        const allIds = newData.flatMap(parent => [
            parent.id,
            ...(parent.linkedTests ? parent.linkedTests.map((child: any) => child.id) : [])
        ]);

        if (newSelectAll) {
            setGetSelectedRowId([...new Set([...getSelectedRowId, ...allIds])]);
        } else {
            setGetSelectedRowId((prevIds: any[]) => prevIds.filter(id => !allIds.includes(id)));
        }
    };

    useEffect(() => {
        const allItemsSelected = analysisResult.every(parent => {
            if (parent.linkedTests) {
                return parent.isSelected && parent.linkedTests.every(child => child.isSelected);
            }
            return parent.isSelected;
        });
        setSelectAll(allItemsSelected);
    }, [analysisResult])


    const isButtonEnabled = () => {
        const allSelectedValid = analysisResult.every(parent => {
            if (parent.isSelected && parent.linkedTests) {
                return parent.linkedTests.every(child => child.isSelected);
            }
            if (parent.linkedTests) {
                return parent.linkedTests.every(child => !child.isSelected);
            }
            return true;
        });
        const noParentSelectedWithUnSelectedChildren = analysisResult.every(parent => {
            if (parent.linkedTests) {
                return parent.isSelected === false || parent.linkedTests.every(child => child.isSelected);
            }
            return true;
        })

        return allSelectedValid && noParentSelectedWithUnSelectedChildren;
    }

    useEffect(() => {
        if (getSelectedRowId) {
            setIsEnablePriceTable(isButtonEnabled);
        }
    }, [getSelectedRowId])

    const handleClick = (user: any) => {
        if (user.isOpen) {
            user.isOpen = false;
            setState((pre) => {
                return pre + 1;
            });
        } else {
            let item: any;
            analysisResult.map((i: any, index: any) => {
                if (i.id === user.id) {
                    item = i.linkedTests;
                }
            })
            user.linkedTests = item;
            user.isOpen = true;
            setState((pre) => {
                return pre + 1;
            });
        }
    };

    const childRender = (item: any) => {
        return (
            <>
                {item.linkedTests.map((child: any, index: any) => {
                    return (
                        <Fragment key={child.id}>
                            <TableRow tabIndex={-1} key={child.index} style={{ backgroundColor: '#00388324' }}>
                                {pageName !== 'view' ? <>
                                    <TableCell style={{ padding: '8px 16px' }}>
                                        <input
                                            type="checkbox"
                                            name="childRow"
                                            onChange={(event: any) => handleChildSelection(item.id, child.id)}
                                            checked={child.isSelected}
                                            id="childItem"
                                        />
                                    </TableCell>
                                </> : null}
                                <TableCell style={{ padding: '4px' }}>{child.code}</TableCell >
                                <TableCell style={{ padding: '4px' }}>{child.testName}</TableCell>
                                <TableCell style={{ padding: '4px' }}>{child.matrixType}</TableCell>
                                <TableCell style={{ padding: '4px' }}>{child.lor}</TableCell>
                                <TableCell style={{ padding: '4px' }}>{child.isSubContracted ? `Yes - ${child.subContractorName}` : 'No'}</TableCell>
                                <TableCell style={{ padding: '4px' }}>{child.testPrice}</TableCell>
                            </TableRow>
                        </Fragment>
                    );
                })}
            </>
        )
    }

    let paddingSize = pageName === 'view' ? '8px 16px' : '4px';

    return (
        <>
            <TableContainer>
                <Table sx={{ minWidth: 700, border: '1px solid #ddd', marginTop: 2 }} aria-label="simple table">
                    <TableHead style={{ backgroundColor: 'rgb(0, 56, 131)' }}>
                        <TableRow style={{ height: '50px' }}>
                            {pageName !== 'view' ? <>
                                <TableCell style={{ width: '15px' }}>
                                    <input
                                        name="selectAllRow"
                                        type="checkbox"
                                        onChange={(event: any) => handleSelectAll()}
                                        checked={selectAll}
                                        id="parentItem"
                                    />
                                </TableCell>
                            </> : null}
                            <TableCell style={{ color: '#fff', padding: paddingSize, width: '56px' }}>Code</TableCell>
                            <TableCell style={{ color: '#fff', padding: '4px', width: '120px', whiteSpace: 'normal', wordBreak: 'break-word', overflowWrap: 'anywhere' }}>Name</TableCell>
                            <TableCell style={{ color: '#fff', padding: '4px', width: '68px' }}>Matrix Type</TableCell>
                            <TableCell style={{ color: '#fff', padding: '4px', width: '86px' }}>LORs</TableCell>
                            <TableCell style={{ color: '#fff', padding: '4px', width: '100px' }}>Subcontracted</TableCell>
                            <TableCell style={{ color: '#fff', padding: '4px', width: '100px' }}>Test Price</TableCell>
                        </TableRow>
                    </TableHead>
                    {loading ? (
                        <p>Loading...</p>
                    ) : (<>
                        <TableBody>
                            {analysisResult
                                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                .map((user: any, index: any) => {
                                    return (
                                        <Fragment key={user.id}>
                                            <TableRow tabIndex={-1} key={user.index}>
                                                {pageName !== 'view' ? <><TableCell style={{ padding: '4px' }}>
                                                    <FormControlLabel control={<Checkbox
                                                        name="billingGroupRow"
                                                        checked={user?.isSelected}
                                                        onChange={(event: any) => handleParentSelection(user.id)}
                                                    />}
                                                        label=""
                                                        sx={{ marginLeft: 0, marginRight: 0 }}
                                                    />
                                                </TableCell></> : null}
                                                <TableCell style={{ padding: paddingSize }}>{user.code} {user.code === 'Grouped' ? <b>*</b> : null}</TableCell >
                                                <TableCell
                                                    style={{
                                                        padding: '4px',
                                                        whiteSpace: 'normal',
                                                        wordBreak: 'break-word',
                                                        overflowWrap: 'anywhere',
                                                    }}
                                                >
                                                    <Tooltip title={user.testName || ''} arrow>
                                                        <span>
                                                            {user?.linkedTests?.length > 0 ? (
                                                                <Link
                                                                    component="button"
                                                                    variant="body2"
                                                                    key={user.id}
                                                                    onClick={() => handleClick(user)}
                                                                >
                                                                    {user.testName}
                                                                </Link>
                                                            ) : (
                                                                <>{user.testName}</>
                                                            )}
                                                        </span>
                                                    </Tooltip>
                                                </TableCell>
                                                <TableCell style={{ padding: '4px' }}>{user.userMatrixType}</TableCell>
                                                <TableCell style={{ padding: '4px' }}>{user.lor}</TableCell>
                                                <TableCell style={{ padding: '4px' }}>{user.isSubContracted ? `Yes - ${user.subContractorName}` : 'No'}</TableCell>
                                                <TableCell style={{ padding: '4px' }}>
                                                    {(pageName !== 'view' && (user.linkedTests == null || user.linkedTests.length === 0)) ? (
                                                        <TextField
                                                            id="outlined-basic"
                                                            label=""
                                                            name="testPrice"
                                                            variant="outlined"
                                                            sx={{
                                                                '.MuiOutlinedInput-input': {
                                                                    width: '75px',
                                                                    padding: '8px 10px',
                                                                    fontSize: '12px'
                                                                }
                                                            }}
                                                            size="small"
                                                            defaultValue={user.testPrice}
                                                            onBlur={(event: any) => handlePriceUpdate(event, user)}
                                                            disabled={user.code === 'Grouped'}
                                                            InputProps={{
                                                                inputComponent: ({ inputRef, ...rest }) => <input ref={inputRef} {...rest} type="text" />,
                                                            }}
                                                        />
                                                    ) : user.testPrice}
                                                </TableCell>
                                            </TableRow>
                                            {user.isOpen ? childRender(user) : null}
                                        </Fragment>
                                    )
                                })}
                        </TableBody>
                    </>)}

                </Table>
                <TablePagination
                    rowsPerPageOptions={[20]}
                    component="div"
                    count={analysisResult.length}
                    page={page}
                    onPageChange={handleChangePage}
                    rowsPerPage={rowsPerPage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />
            </TableContainer>
        </>
    );
}

export default SingleRowExpand;
